
















import Vue from "vue";

export default Vue.extend({
  name: "delete-goal-modal",
  components: {},
  props: {
    showDialog: Boolean,
  },
  data() {
    return {};
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
      }
    },
  },
  computed: {
    showModal: {
      get() {
        return (this as any).showDialog;
      },
      set() {},
    },
  },
  methods: {},
});
